/**
 * Encaptulates functionality to store and retrieve BNBO data from the data store
 */
import { ESInterface } from "src/compentsModus/ESInterface";
import { BNBOProject, ProjectsPersistenceInterface, SFEPersistenceInterface } from "./BNBOState";
import { ObjectVersionRegister, OptimisticLockingWrapper } from "src/common/managers/ESVersionedPersistance";

export type SFERecord = any;



export class BNBOProjectsPersistence implements ProjectsPersistenceInterface {

   projectsESIndexName;
   es: ESInterface;
   versions
   dw;

   static instance: BNBOProjectsPersistence;

   static setInstance(instance: BNBOProjectsPersistence) {
      BNBOProjectsPersistence.instance = instance;
   }

   static getInstance(): BNBOProjectsPersistence {
      if (!BNBOProjectsPersistence.instance) {
         throw new Error("BNBOProjectsPersistence not initialized");
      }
      return BNBOProjectsPersistence.instance;
   }

   constructor(projectsESIndexName: string, userId: string) {
      this.projectsESIndexName = projectsESIndexName;
      this.es = new ESInterface(this.projectsESIndexName)
      this.versions = new ObjectVersionRegister();
      this.dw = new OptimisticLockingWrapper(this.es, this.versions, (data) => data.id, userId);
   }

   async listProjects(): Promise<BNBOProject[]> {
      // Retrieve projects from the data store
      try {
         let res = await this.dw.listDocuments();
         if (res && res.length > 0) {
            return (res as BNBOProject[]);
         } else {
            return [];
         }
      } catch (error: any) {
         throw new Error(error);
      }
   }

   async getProject(projectId: string): Promise<BNBOProject> {
      try {
         let record = await this.dw.getDocument(projectId, {});
         return (record as BNBOProject);
      } catch (error: any) {
         throw new Error(error);
      }
   }

   async saveProject(project: BNBOProject): Promise<void> {
      // Save project to the data store
      try {
         await this.dw.updateDocument(project.id, project);
         return
      } catch (error: any) {
         throw new Error(error);
      }
   }

   async createProject(project: BNBOProject): Promise<void> {
      // Save project to the data store
      this.saveProject(project)
         .then(() => {
            // Create sfe/lodsejer database for project
            let indexMappings =
            {
               "properties": {
                  "lodsejer": {
                     "type": "text"
                  },
                  "matrikler": {
                     "type": "text"
                  },
                  "markeDele": {
                     "type": "text"
                  },
                  "marker": {
                     "type": "text"
                  },
                  "områder": {
                     "type": "text"
                  },
                  "bnboer": {
                     "type": "text"
                  },
                  "dele": {
                     "type": "text"
                  },
               }
            }
            this.es.createIndex(project.esIndexName, { mappings: { ...indexMappings, "_meta": { "CreatedBy": "klaus bech" } } })
               .then(() => {
                  // alert("Got result " + JSON.stringify(res));
               })
               .catch((error) => {
                  alert("Got error " + (error.message || error));
               })
         })
   }

   async deleteProject(projectId: string): Promise<void> {
      // Save project to the data store
      try {
         await this.dw.deleteDocument(projectId);
         return
      } catch (error: any) {
         throw new Error(error);
      }
   }

}

export class BNBOSFEPersistence implements SFEPersistenceInterface {

   ESIndexName;
   es: ESInterface;
   versions;
   dw;

   static instance: BNBOSFEPersistence;

   static setInstance(instance: BNBOSFEPersistence) {
      BNBOSFEPersistence.instance = instance;
   }

   static getInstance(): BNBOSFEPersistence {
      if (!BNBOSFEPersistence.instance) {
         throw new Error("BNBOSFEPersistence not initialized");
      }
      return BNBOSFEPersistence.instance;
   }

   constructor(ESIndexName: string, userId?: string) {
      this.ESIndexName = ESIndexName;
      this.es = new ESInterface(this.ESIndexName)
      this.versions = new ObjectVersionRegister();
      this.dw = new OptimisticLockingWrapper(this.es, this.versions, (data) => data.lodsejerid, userId);
   }

   async listSFEs(): Promise<SFERecord[]> {
      // Retrieve SFEs from the data store
      // Retrieve projects from the data store
      try {
         let res = await this.dw.listDocuments();
         if (res && res.length > 0) {
            return res as SFERecord[];
         } else {
            return [];
         }
      } catch (error: any) {
         throw new Error(error);
      }
   }

   async removeAllSFEs(): Promise<void> {
      // Remove all sfes from mindex but do not delete index
      try {
         await this.dw.emptyTheIndex(this.ESIndexName);
         return;
      } catch (error: any) {
         throw new Error(error);
      }
   }

   async getSFE(sfeId: string): Promise<SFERecord> {
      // Retrieve SFE from the data store
      try {
         let record = await this.dw.getDocument(sfeId, {});
         return record as SFERecord;
      } catch (error: any) {
         throw new Error(error);
      }
   }

   async saveSFE(sfeId: string, sfe: SFERecord): Promise<void> {
      // Save SFE to the data store
      try {
         await this.dw.updateDocument(sfeId, sfe);
         return;
      } catch (error: any) {
         throw new Error(error);
      }
   }

   async deleteSFE(sfeId: string): Promise<void> {
      // Delete SFE from the data store
      try {
         await this.dw.deleteDocument(sfeId);
         return;
      } catch (error: any) {
         throw new Error(error);
      }
   }
}
